import { render, staticRenderFns } from "./Sap.vue?vue&type=template&id=d12784fa&scoped=true&"
import script from "./Sap.vue?vue&type=script&lang=js&"
export * from "./Sap.vue?vue&type=script&lang=js&"
import style0 from "./Sap.vue?vue&type=style&index=0&id=d12784fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12784fa",
  null
  
)

export default component.exports